import { useGetAccountQuery, useGetMeQuery } from '@/api'

/**
 * Whether the signed-in account is the platform's super admin, who manages
 * the roles organizations give their members (ADR 0003). Only hides or shows
 * screens: the gateway and auth-service refuse everybody else.
 *
 * Both queries are cached by RTK Query and already fetched by the app shell.
 */
export function useIsPlatformAdmin(): boolean {
	const { data: me } = useGetMeQuery()
	const { data: account } = useGetAccountQuery(me?.id ?? '', { skip: !me?.id })
	return account?.role === 'ADMIN'
}
